






import { Vue, Component } from 'vue-property-decorator';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { getRule } from '../api';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class Rule extends Vue {
  obj: any = {};
  show: boolean = false;
  activeTab = 0;
  async created() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/image/default/2023-09-25/5beadd06122151bed62fde38c29fbf6a.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2023大渡口十大江湖菜评选活动',
      url: location.href,
      subtitle: ``,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023大渡口十大江湖菜评选活动',
        subtitle: ``,
        image: cover,
      });
    }
    const res = await getRule();
    this.obj = res.data;
    if (res.data) {
      setTimeout(() => {
        this.show = true;
      }, 500);
    }
  }
}
